import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import NoticeBanner from "../shared/NoticeBanner";
import { useIsDesktop } from "../shared/hooks/useIsDesktop";

/**
 * メール配信の補足説明
 * PC: Tooltip / SP: Dialog
 */
function MailSettingsHelp({ hidden = false }) {
  const [open, setOpen] = useState(false);
  const isDesktop = useIsDesktop();

  if (hidden) return null;

  const content =
    "お知らせメールの受信設定にかかわらず、重要なお知らせはすべてのユーザーに配信されます。";

  if (isDesktop) {
    return (
      <Tooltip title={content} arrow>
        <IconButton
          size="small"
          sx={{ color: "text.secondary" }}
          aria-label="メール設定の注意事項"
        >
          <ErrorOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <IconButton
        size="small"
        sx={{ color: "text.secondary" }}
        aria-label="メール設定の注意事項"
        onClick={() => setOpen(true)}
      >
        <ErrorOutlineIcon fontSize="small" />
      </IconButton>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogContent>
          <Typography>{content}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>閉じる</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function MailSettingsSection({
  emailRegistered,
  isDesktop,
  sectionStyle,
  sectionTitleStyle,
  sectionContentStyle,
  mailMagazineOptions,
  mailMagazineStatus,
  isSubmittingMailMagazine,
  handleChangeMailMagazineStatus,
  hiddenHelp = false,
}) {
  return (
    <Box sx={sectionStyle}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography sx={{ ...sectionTitleStyle, mb: 0 }}>メール設定</Typography>
        <MailSettingsHelp hidden={hiddenHelp} />
      </Box>

      {emailRegistered ? (
        <Box sx={sectionContentStyle}>
          <Typography sx={{ fontSize: "14px", mt: 2 }}>
            配信を希望する項目にチェックをつけてください。
          </Typography>

          <FormGroup>
            {mailMagazineOptions.map((option) => (
              <FormControlLabel
                key={option.category}
                control={
                  <Checkbox
                    checked={mailMagazineStatus[option.category] || false}
                    disabled={isSubmittingMailMagazine}
                    onChange={(event) =>
                      handleChangeMailMagazineStatus(
                        option.category,
                        option.label,
                        event.target.checked,
                      )
                    }
                  />
                }
                label={option.label}
              />
            ))}
          </FormGroup>
        </Box>
      ) : (
        <Box
          sx={{
            ...sectionContentStyle,
            width: isDesktop ? 340 : "100%",
            mt: 2,
          }}
        >
          <NoticeBanner
            text={
              "メールアドレスを登録すると、\nメールを受け取ることができます。"
            }
          />
        </Box>
      )}
    </Box>
  );
}
